import axios from "axios";
import { GURL } from "./global";

export const CreateNotice = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Notices/create`, f);
};

export const GetAllNotice = () => {
  const url = `${GURL}/Notice/v1/Notices`;
  return axios.get(url);
};
export const GetNoticeBySearchParams = (
  searchParams: any,
  skip: number,
  take: number
) => {
  const url = `${GURL}/Notice/v1/Notices/GetNotice/${searchParams}?searchParams=${searchParams}&skip=${0}&take=${1000}`;
  return axios.get(url);
};

export const GetNoticeById = (id: any) => {
  const url = `${GURL}/Notice/v1/Notices/GetById/${id}?id=${id}`;

  //console.log(url);

  return axios.get(url);
};

export const GetNoticesPaged = (
  skip: any,
  take: any,
  positionId: any,
  qry: any,
  categoryId: any,
  filter: any
) => {
  const url = `${GURL}/Notice/v1/Notices/GetPaged?skip=${0}&take=${1000}&positionId=${positionId}&qry=${qry}&categoryId=${categoryId}&filter=${filter}`;
  // console.log(url);
  return axios.get(url);
};

export const GetMyNotices = (noticetype: number) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/GetMyNotices?skip=${0}&take=${1001}`;
  return axios.get(url);
};

export const GetMyNotices4Chat = (isPublished: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/GetMyNotices4Chat?isPublished=${isPublished}`;
  return axios.get(url);
};

export const GetMyNotices4Chat2 = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Notices/GetMyNotices4Chat2`, f);
};

export const GetPreDraft = () => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/GetPreDraft`;
  return axios.get(url);
};

export const SetUpDraft = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Notices/SetUpNewDraft`, f);
};

export const AddView = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Notices/AddView`, f);
};

export const CoppyNotice = async (id: string) => {
  try {
    const response = await axios.post(`${GURL}/Notice/v1/Notices/Coppy`, null, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        id,
      },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data || "Error occurred while copying data"
    );
  }
};
export const CoppyNoticed = (id: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Notices/Coppy`, { id });
};

export const GetViews = (noticeId: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/GetViews?noticeId=${noticeId}`;
  return axios.get(url);
};
export const GetViewsId = (noticeId: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/GetViewsId?noticeId=${noticeId}`;
  return axios.get(url);
};
export const UpdateNotice = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Notices/UpdateNotice`, f);
};

export const RejectReson = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Notices/RejectReson`, f);
};

export const GetLastNoticeRejectionReason = (noticeId: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Notice/v1/Notices/GetLastReason?noticeId=${noticeId}`;
  return axios.get(url);
};
